import { AppBar, Container, Toolbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HideOnScroll from "../../components/HideOnScroll.js";
import HeaderMenuButton from "../../components/HeaderMenuButton.js";
import ContentTypePills from "../../components/ContentTypePills.js";
import { getContentTypeSlug } from "../../utils/utils.js";

/**
 * Explore's fixed, hide-on-scroll header: the drawer button and the content
 * type pills, each pill navigating to that type's explore path.
 */
export default function ExploreNewHeader({
  toggleDrawer,
  drawerWidth,
  activeFilter,
  basePath = "/explore",
}) {
  const navigate = useNavigate();

  // "all" is the base path; content types append their slug segment
  const handleChange = (value) =>
    navigate(value === "all" ? basePath : `${basePath}/${getContentTypeSlug(value)}`);

  return (
    <>
      {/* Spacer — keeps content from sliding under the fixed AppBar */}
      <Toolbar sx={{ mt: 2.5, mb: 2.5 }} />
      <HideOnScroll>
        <AppBar
          color="inherit"
          sx={{
            boxShadow: "none",
            backgroundImage: "none",
            width: { md: `calc(100% - ${drawerWidth}px)` },
            ml: { md: `${drawerWidth}px` },
            pt: 2,
            pb: 2,
            overflowX: "auto",
            // Hide the scrollbar visually while keeping scroll functionality
            "&::-webkit-scrollbar": { display: "none" },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          <Container maxWidth="lg">
            <Toolbar disableGutters>
              <HeaderMenuButton onClick={toggleDrawer} sx={{ mr: 2 }} />
              {/* Compact: all four fit across a phone without scrolling */}
              <ContentTypePills
                compact
                value={activeFilter}
                onChange={handleChange}
              />
            </Toolbar>
          </Container>
        </AppBar>
      </HideOnScroll>
    </>
  );
}
